import React from 'react';
import '@/App.css';
import axios from 'axios';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { AuthProvider } from '@/contexts/AuthContext';
import ProtectedRoute from '@/components/ProtectedRoute';
import Layout from '@/components/Layout';
import Login from '@/pages/Login';
import Dashboard from '@/pages/Dashboard';
import Patients from '@/pages/Patients';
import PatientHistory from '@/pages/PatientHistory';
import PatientLookup from '@/pages/PatientLookup';
import Doctors from '@/pages/Doctors';
import Medicines from '@/pages/Medicines';
import Procedures from '@/pages/Procedures';
import Consultations from '@/pages/Consultations';
import Billing from '@/pages/Billing';
import AIFeatures from '@/pages/AIFeatures';
import PurchaseHistory from '@/pages/PurchaseHistory';
import Users from '@/pages/Users';
import AuditLogs from '@/pages/AuditLogs';
import Cleanup from '@/pages/Cleanup';

axios.defaults.withCredentials = true;

// Role constants (avoid inline arrays in JSX props that cause re-renders)
const ROLES_ALL = ['admin', 'staff', 'doctor'];
const ROLES_ADMIN = ['admin'];
const ROLES_ADMIN_STAFF = ['admin', 'staff'];
const ROLES_ADMIN_DOCTOR = ['admin', 'doctor'];

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route
              path="/"
              element={
                <ProtectedRoute>
                  <Layout />
                </ProtectedRoute>
              }
            >
              <Route index element={<Dashboard />} />
              <Route
                path="patient-lookup"
                element={
                  <ProtectedRoute roles={ROLES_ALL}>
                    <PatientLookup />
                  </ProtectedRoute>
                }
              />
              <Route path="patients" element={<Patients />} />
              <Route
                path="patients/:patientId/history"
                element={
                  <ProtectedRoute roles={ROLES_ALL}>
                    <PatientHistory />
                  </ProtectedRoute>
                }
              />
              <Route
                path="doctors"
                element={
                  <ProtectedRoute roles={ROLES_ADMIN}>
                    <Doctors />
                  </ProtectedRoute>
                }
              />
              <Route
                path="medicines"
                element={
                  <ProtectedRoute roles={ROLES_ADMIN_STAFF}>
                    <Medicines />
                  </ProtectedRoute>
                }
              />
              <Route
                path="procedures"
                element={
                  <ProtectedRoute roles={ROLES_ADMIN_DOCTOR}>
                    <Procedures />
                  </ProtectedRoute>
                }
              />
              <Route
                path="consultations"
                element={
                  <ProtectedRoute roles={ROLES_ALL}>
                    <Consultations />
                  </ProtectedRoute>
                }
              />
              <Route
                path="billing"
                element={
                  <ProtectedRoute roles={ROLES_ADMIN_STAFF}>
                    <Billing />
                  </ProtectedRoute>
                }
              />
              <Route
                path="ai-features"
                element={
                  <ProtectedRoute roles={ROLES_ALL}>
                    <AIFeatures />
                  </ProtectedRoute>
                }
              />
              <Route
                path="purchase-history"
                element={
                  <ProtectedRoute roles={ROLES_ADMIN_STAFF}>
                    <PurchaseHistory />
                  </ProtectedRoute>
                }
              />
              <Route
                path="users"
                element={
                  <ProtectedRoute roles={ROLES_ADMIN}>
                    <Users />
                  </ProtectedRoute>
                }
              />
              <Route
                path="audit-logs"
                element={
                  <ProtectedRoute roles={ROLES_ADMIN}>
                    <AuditLogs />
                  </ProtectedRoute>
                }
              />
              <Route
                path="cleanup"
                element={
                  <ProtectedRoute roles={ROLES_ADMIN}>
                    <Cleanup />
                  </ProtectedRoute>
                }
              />
            </Route>
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
